import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { Fade } from 'react-reveal';
import { Actions } from '../../../flux';
import { images, texts, certificacao_educacao } from '../../../settings';
import { DelayLink, SliderText, CardAccordion, CardAccordionHeader, CardAccordionBody } from '../../../components';

import '../Iniciativas.scss';
import './CertificacaoEducacao.scss';

class CertificacaoEducacao extends Component {
  constructor(props) {
    super(props);

    this.contentText = React.createRef();
  }

  scrollTop = () => {
    window.scrollTo({ top: this.contentText.current.offsetTop });
  };

  componentDidMount = () => {
    Actions.headerIntern();
    this.scrollTop();
  };

  render = () => {
    return (
      <div className="views" ref={this.contentText}>
        <Helmet>
          <title>Certificação e educação - Iniciativas - {texts.title}</title>
        </Helmet>

        <div
          className="iniciativas-home certificacao-educacao-home page-gradient page-gradient--yellow bg-gray"
          ref="certificacao-educacao-home"
        >
          <section className="iniciativas-area page--yellow">
            <div className="container container--large">
              <div className="row">
                <div className="col-12">
                  <Fade bottom>
                    <div className={`card card--page-body card--yellow`}>
                      <div className="card__content">
                        <div className="card__content__header">
                          <DelayLink
                            to={`/estrategias/para-o-mercado`}
                            className="button button--aylen button--gray-500 button--border-medium button--size-m button--round-l button--text-thick"
                          >
                            Voltar
                          </DelayLink>
                          <h1 className="title title--gray">Certificação e educação</h1>
                        </div>
                        <div className="card__content__body">
                          <p>
                            Batemos a marca de 550 mil certificações emitidas, um aumento de 10% em relação ao total do
                            ano anterior.
                            <br />
                            Esses números englobam as quatro qualificações que oferecemos ao mercado.
                          </p>
                        </div>
                      </div>

                      {/* <div className="card__image">
												<img src={content.image} />
											</div> */}
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          </section>

          <section className="iniciativas-body">
            <div className="container container--large">
              <div className="row">
                <div className="col-12">
                  <Fade bottom>
                    <CardAccordion
                      noBorder
                      color="yellow"
                      header={
                        <CardAccordionHeader>
                          <h2 className="title">Conheça nossas certificações</h2>
                        </CardAccordionHeader>
                      }
                      content={
                        <CardAccordionBody>
                          <SliderText items={certificacao_educacao.items} color={'yellow'} />
                        </CardAccordionBody>
                      }
                    />
                  </Fade>
                </div>
              </div>
            </div>

            <div className="container container--large">
              <div className="row">
                <div className="col-12">
                  <Fade bottom>
                    <div className="card card--no-border card--horas card--secondary">
                      <div className="card__content card__content--full">
                        <div className="card__content__body">
                          <h3 className="title title--small yellow">Certificações emitidas em 2019 por região</h3>
                          <p>
                            A maioria das aprovações do ano corresponde à CPA-10 (Certificação Profissional ANBIMA –
                            Série 10), com 26.820 certificados. No entanto, a procura dos profissionais tem crescido
                            pela CEA: os 3.382 aprovados no exame em 2019 correspondem a um aumento de 111% em relação
                            ao ano anterior.
                          </p>
                          <p>
                            Todos esses profissionais estão distribuídos pelas cinco regiões do país, com maior volume
                            no Sudeste e no Sul.
                          </p>

                          <div className="mapa_desk">
                            <img src={images.iniciativas.certificacao_educacao.mapa} />
                          </div>

                          <div className="mapa_mobile">
                            <img src={images.iniciativas.certificacao_educacao.mapa_mobile} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </Fade>
                </div>
              </div>
            </div>

            <div className="container container--large">
              <div className="row">
                <div className="col-12">
                  <Fade bottom>
                    <div className="card card--no-border card--final">
                      <div className="card__content card__content--full">
                        <div className="card__content__body">
                          <h3 className="title title--small yellow">Nova CGA</h3>

                          <p>
                            Uma certificação que reflita melhor a realidade do mercado e seja adequada ao momento
                            profissional de cada gestor. <br />
                            Esse foi o objetivo na hora de reformularmos a CGA. Ela agora é dividida em três exames com
                            focos distintos:{' '}
                          </p>

                          <ul className="bullets bullets--yellow">
                            <li>
                              Adaptação da prova atual, um dos exames é voltado para quem está começando na carreira de
                              gestão de recursos de terceiros e foca nos fundos regulados pela Instrução CVM 555.
                            </li>
                            <li>
                              Outro exame, lançado com a reformulação, é destinado aos profissionais que atuam com
                              gestão de fundos imobiliários, FIDCs (Fundos de Investimento em Direitos Creditórios) e
                              FIPs (Fundos de Investimento em Participações).
                            </li>
                            <li>
                              Também foi criada uma prova voltada a técnicas e ferramentas necessárias para análise e
                              gestão, assim como para quem cuida de fundos mútuos.
                            </li>
                          </ul>

                          <p>
                            Quem é aprovado nos três módulos consegue a CGA Completa – adquirida automaticamente por
                            quem possuía a CGA antes da mudança. Também foi criado um curso de atualização para os
                            profissionais que têm a certificação, mas não atuam na atividade de gestão. Os assuntos
                            tratados nas aulas serão definidos a partir de um teste preliminar, que avalia os
                            conhecimentos do profissional nos temas mais relevantes para a profissão.
                          </p>
                        </div>
                      </div>
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    );
  };
}

export { CertificacaoEducacao };
